import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import "highcharts";
import * as highcharts from "highcharts";
import * as moment from "moment";
import { TimeProvider } from "../../providers/time/time";
import * as Plotly from "plotly.js";

@Component({
  selector: "kpichart",
  templateUrl: "kpichart.html",
})
export class KpichartComponent implements OnInit {
  chart: any;
  @ViewChild("plotlyChart") plotly: ElementRef;
  _data: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  series: any;
  unit = "%";
  @Input() average;
  @Input() set data(val) {
    this.series = val;

    this._data.next(val);
  }
  plotlyData;
  constructor(public time: TimeProvider) {}

  ngOnInit(): void {
    this.watchSeriesChanges();
  }

  watchSeriesChanges() {
    this._data.subscribe(
      (data) => {
        if (data !== undefined && data !== []) {
          this.plotlyData = this.series;
          this.createChart();
        } else {
          this.plotlyData = [];
        }
      },
      (error) => {}
    );
  }

  createChart() {
    if (this.plotlyData.length !== 0) {
      if (this.plotlyData.kpi == "kpish") {
        this.unit = "hours";
      } else {
        this.unit = "%";
      }
      let average = [];
      let yData = this.plotlyData.series[0].data;
      let xData = this.plotlyData.categories.map((d) => new Date(d));
      xData.forEach((element) => {
        average.push(this.plotlyData.avgVal);
      });

      const layout = {
        font: { size: 10 },
        margin: {
          l: 90,
          r: 0,
          // b: 0,k
          t: 90,
          pad: 40,
        },
        showLegend: false,
        paper_bgcolor: "white",
        plot_bgcolor: "white",
        xaxis: {
          type: "date",
        },
        yaxis: {
          title: "Values (" + this.unit + ")",
        },
        titlefont: {
          size: 16,
        },
        legend: {
          x: 0,
          y: 1.2,
          bgcolor: "rgba(255, 255, 255, 0)",
          bordercolor: "rgba(255, 255, 255, 0)",
        },
      };

      var data = [
        {
          x: xData,
          y: yData,
          hovertemplate: "%{y:.2f}" + this.unit,
          type: "bar",
          name: "Current period values ",
          marker: {
            color: "rgb(77, 33, 122)",
          },
        },
        {
          x: xData,
          y: average,
          hovertemplate: "%{y:.1f}" + this.unit,
          mode: "lines",
          name: "Previous period average",
          line: {
            color: "rgb(115, 191, 217)",
          },
        },
      ];
      const config = {
        responsive: true,
        displaylogo: false,
        displayModeBar: false,
      };
      Plotly.newPlot(this.plotly.nativeElement, data, layout, config);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/kpichart/kpichart.ts